export default "__VITE_ASSET__DIJcZm34__"